import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import DeleteModalSkeleton from '../../components/Skeletons/DeleteModalSkeleton';

const DeleteUserModal = ({ deleteUserModal, loading, handleDeleteUserModalClose, handleDeleteUser, data }) => {
  const { t } = useTranslation();
  const { deleteEmail, setDeleteEmail, deleteUserData } = data;

  return (
    <Modal show={deleteUserModal}>
      <ModalHeading heading={t('screens.users.deleteUserTitle', { name: deleteUserData.name })} />
      {loading ? (
        <DeleteModalSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }}>
          <InputsSection style={{ width: '34rem' }}>
            <InputBox
              label={t('screens.users.deletePromptLabel', { email: deleteUserData.email })}
              placeholder={deleteUserData.email}
              value={deleteEmail.value}
              onChange={event => {
                setDeleteEmail({ value: event.target.value, error: '' });
              }}
              errorMessage={deleteEmail.error}
              style={{ width: '30rem' }}
            />
            <p className='dangerText'>{t('screens.users.deleteDangerText')}</p>
          </InputsSection>
          <InputsSection style={{ width: '34rem' }}>
            <p className='primaryText'>{t('screens.users.deleteAdvice')}</p>
          </InputsSection>
          <ModalButtons submitButtonLabel={t('screens.users.deleteBtn')} onSubmit={handleDeleteUser} cancelButtonLabel={t('screens.users.cancel')} onCancel={handleDeleteUserModalClose} />
        </ModalForm>
      )}
    </Modal>
  );
};

export default DeleteUserModal;
